import { render, staticRenderFns } from "./ManualBulkUpdate.vue?vue&type=template&id=2859c4f1"
import script from "./ManualBulkUpdate.vue?vue&type=script&lang=ts"
export * from "./ManualBulkUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports